import styled from "@emotion/styled";
import React from "react";
import { formatNumber, i18n, mediaQuery } from "src/common";
import { Flex, Grid, Text } from 'src/components';
import { colors } from "src/theme";

const HeaderGrid = styled(Grid)({
  minWidth: 0,
});

const Logo = styled.img({
  maxHeight: '28px',
  minHeight: '28px',
  maxWidth: '86px',
  flexShrink: 0,
});

const LeftCell = styled(Flex)({
  minWidth: 0,
  flexDirection: 'column',
  alignItems: 'flex-start',

  [mediaQuery('laptopL')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

const TextAlignStyle = styled.div({
  textAlign: 'right',
  minWidth: 0,
});

const PriceRow = styled.div({
  display: 'inline-flex',
  alignItems: 'baseline',
  gap: '0',
  whiteSpace: 'nowrap',
  '& > *': { flexShrink: 0 },
})

interface OfferAdditionalHeaderCardProps {
  monthlyPrice?: number;
  yearlyPrice?: number;
  priceLabel?: string;
  logoUrl?: string;
  className?: string;
  offerSubtitle?: string;
  offerSubDescription?: string;
}

// zove se card iako je samo dio carda - Header
export const OfferAdditionalHeaderCard = ({ monthlyPrice, yearlyPrice, priceLabel, logoUrl, offerSubtitle, offerSubDescription }: OfferAdditionalHeaderCardProps) => (
  <HeaderGrid columns='2fr 1fr' columnGap={16} align='center'>
    <LeftCell gap={12}>
      <Logo src={logoUrl} alt="logo" />
      {(offerSubtitle ?? offerSubDescription) && (
        <Flex vertical style={{ minWidth: 0 }}>
          {offerSubtitle && <Text type="sBase" bold color={colors.text1} style={{ overflowWrap: 'break-word', wordBreak: 'break-word' }}>{offerSubtitle}</Text>}
          {offerSubDescription && <Text type="tiny" color={colors.text2}>{offerSubDescription}</Text>}
        </Flex>
      )}
    </LeftCell>
    <TextAlignStyle>
      <Flex vertical align="flex-end">
        {monthlyPrice != null && (
          <>
            <PriceRow>
              <Text type='sLarge' bold style={{ whiteSpace: 'nowrap' }}>{`${formatNumber(monthlyPrice)}€`}</Text>
              <Text type='small' color={colors.text4} style={{ whiteSpace: 'nowrap' }}>{priceLabel}</Text>
            </PriceRow>
            <Text type='tiny' color={colors.text4}>{i18n.t('components.cards.offerHeaderCard.yearlyTotal', { yearlyPrice: formatNumber(yearlyPrice) })}</Text>
          </>
        )}
      </Flex>
    </TextAlignStyle>
  </HeaderGrid>
)